var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    _vm._.button,
    _vm.small && _vm._.small,
    _vm.link && _vm._.link,
    _vm.gray && _vm._.gray,
    _vm.inline && _vm._.inline,
    _vm.disabled && _vm._.disabled ],on:{"click":_vm.handleClick}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }